import * as React from 'react';
const SvgFolder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.542 5.208a2 2 0 0 1 2-2h3.147c.565 0 1.112.199 1.547.56l1.828 1.524h6.395a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H3.542a2 2 0 0 1-2-2zm7.079.834L7.276 4.92a.92.92 0 0 0-.587-.213H3.542a.5.5 0 0 0-.5.5v2.167h3.647a.92.92 0 0 0 .587-.212zM3.042 8.875v5.917a.5.5 0 0 0 .5.5h12.917a.5.5 0 0 0 .5-.5v-7.5a.5.5 0 0 0-.5-.5h-6.395L8.236 8.315c-.434.362-.982.56-1.547.56z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFolder;
